import { Injectable } from '@angular/core';
import { LocalstorageService } from './localstorage.service';
import { MerchantVsSubscriptionControllerService } from "./gen";

@Injectable({
  providedIn: 'root',
})

export class FeatureService {
  result: boolean = false;

  constructor(
    private ls: LocalstorageService,
    private mvs: MerchantVsSubscriptionControllerService) { }

  isFeatureEnabled(feature: string): boolean {
    const merchant = this.ls.getMerchant();

    if (feature === 'receiptHTML') {
      return merchant.id === 3 || merchant.id === 15 || merchant.id === 36
        || merchant.id === 47 || merchant.id === 48 || merchant.id === 49
        || merchant.id === 50 || merchant.id === 52 || merchant.id === 39 || merchant.id === 54
        || merchant.id === 57 || merchant.id === 59 || merchant.id === 60 || merchant.id === 61
        || merchant.id === 66 || merchant.id === 69 || merchant.id === 67 || merchant.id === 70;
    }

    // 3 Chakz demo
    if (feature === 'lcdScreen') {
      return merchant.id === 3 || merchant.id === 52 || merchant.id === 47 || merchant.id === 59 || merchant.id === 69;
    }

    // 3
    if (feature === 'disableAutoPrint') {
      return merchant.id === 3 || merchant.id === 50 || merchant.id === 56 || merchant.id === 62 || merchant.id === 61
        || merchant.id === 60 || merchant.id === 64 || merchant.id === 65 || merchant.id === 66 || merchant.id === 68 || merchant.id === 70;
    }

    // 3
    if (feature === 'paxNoModule') {
      return merchant.id === 3 || merchant.id === 48 || merchant.id === 49 || merchant.id === 52;
    }

    if (feature === 'voidPermission') {
      return merchant.id === 3 || merchant.id === 9999 || merchant.id === 47 || merchant.id === 48
        || merchant.id === 49 || merchant.id === 50 || merchant.id === 52 || merchant.id === 69
        || merchant.id === 53 || merchant.id === 56 || merchant.id === 60 || merchant.id === 39 || merchant.id === 66 || merchant.id === 70;
    }

    if (feature === 'cancelPermission') {
      return merchant.id === 3 || merchant.id === 9999 || merchant.id === 47 || merchant.id === 48
        || merchant.id === 49 || merchant.id === 50 || merchant.id === 52
        || merchant.id === 53 || merchant.id === 56 || merchant.id === 69;
    }

    if (feature === 'voidCashInOutPermission') {
      return merchant.id === 3 || merchant.id === 60 || merchant.id === 39 || merchant.id === 66 || merchant.id === 70
        || merchant.id === 69;
    }

    if (feature === 'discountPermission') {
      return merchant.id === 3 || merchant.id === 9999 || merchant.id === 47 || merchant.id === 48
        || merchant.id === 49 || merchant.id === 50 || merchant.id === 52
        || merchant.id === 53 || merchant.id === 56 || merchant.id === 60 || merchant.id === 69;
    }

    if (feature === 'editTransactionPermission') {
      return merchant.id === 3 || merchant.id === 39 || merchant.id === 47 || merchant.id === 48
        || merchant.id === 49 || merchant.id === 50 || merchant.id === 52 || merchant.id === 53
        || merchant.id === 56 || merchant.id === 60 || merchant.id === 66 || merchant.id === 69 || merchant.id === 70;
    }

    if (feature === 'disableDiscountRemark') {
      return merchant.id === 3 || merchant.id === 60 || merchant.id === 66 || merchant.id === 69 || merchant.id === 70;
    }

    if (feature === 'allowEditPrice') {
      return merchant.id === 3 || merchant.id === 39 || merchant.id === 40 || merchant.id === 41 || merchant.id === 54
        || merchant.id === 57 || merchant.id === 58 || merchant.id === 60 || merchant.id === 61 || merchant.id === 62
        || merchant.id === 63 || merchant.id === 64 || merchant.id === 66 || merchant.id === 69 || merchant.id === 70;

    }

    if (feature === 'allowOpenItem') {
      return merchant.id === 3 || merchant.id === 39 || merchant.id === 40 || merchant.id === 41
        || merchant.id === 44 || merchant.id === 47 || merchant.id === 48 || merchant.id === 49 || merchant.id === 50
        || merchant.id === 52 || merchant.id === 53 || merchant.id === 54 || merchant.id === 57 || merchant.id === 58
        || merchant.id === 60 || merchant.id === 61 || merchant.id === 62 || merchant.id === 63 || merchant.id === 64
        || merchant.id === 65 || merchant.id === 66 || merchant.id === 68 || merchant.id === 69 || merchant.id === 67 || merchant.id === 70;;
    }

    if (feature === 'requirePrinterId') {
      return merchant.id === 50 || merchant.id === 60 || merchant.id === 39 || merchant.id === 61;
    }


    if (feature === 'requirePrintCustomerOrderReceipt') {
      return merchant.id === 3 || merchant.id === 58;
    }

    if (feature === 'orderItemRowPrefixQty') {
      return merchant.id === 61;
    }


    return false;
  }

  isAllow(feature: string): boolean {
    this.mvs.getListMerchantSubscriptionKeyValuePost({ merchantId: this.ls.getMerchant().id })
      .subscribe((res) => {
        for (var idx in res) {
          // (S01): Allow user to clock in and out staff
          if (res[idx].key === feature) {
            return this.result = true;
          }
        }
        return this.result;
      });
    return this.result;
  }
}
